import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getJobsContent } from 'Components/InfoJobs/Redux/selectors';
import { fetchJobsContent } from 'Components/InfoJobs/Redux/thunks';
import InfoJobs from 'Components/InfoJobs/InfoJobs';

interface IPropsInternal {
  content: Julius.Website.JobsPageViewModel;
  fetchJobsContent: () => void;
}

type Props = IPropsInternal;

class InfoJobsContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchJobsContent();
  }

  render() {
    return <InfoJobs content={ this.props.content } />;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    content: getJobsContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchJobsContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoJobsContainer);


// WEBPACK FOOTER //
// ./src/components/InfoJobs/InfoJobsContainer.tsx